import cn from "../assets/lang/cn.json";

export default cn;